export function roundFloat(number = 0, places = 0) {
    const multiplier = Math.pow(10, places);
    return Math.round(number*multiplier) / multiplier;
}
